import { Ability } from "../../types/enum/Ability"
import type { Pkm } from "../../types/enum/Pokemon"
import { mapToObj } from "../../utils/map"
import { precomputedPokemonsImplemented } from "./precomputed-pokemons"

const data = new Map<Ability, Pkm[]>()

Object.values(Ability).map((ability) => {
  data.set(
    ability,
    precomputedPokemonsImplemented
      .filter((pokemon) => pokemon.skill === ability)
      .map((pokemon) => pokemon.name)
  )
})

export const PRECOMPUTED_POKEMONS_PER_ABILITY = mapToObj(data) as {
  [key in Ability]: Pkm[]
}
